export default function About() {
  return (
    <section id="about" className="about-section">
      <div className="about-content">
        <div className="about-text">
          <div className="section-header">
      <h2>About MarsX Technology</h2>
            <p className="section-subtitle">
              Leading the digital transformation journey for businesses worldwide
            </p>
          </div>
      <p>
            MarsX Technology is a premier software development company focused on building
            scalable digital solutions for startups and SMEs. With expertise in modern web,
            mobile, custom software, and RFID-based systems, we help businesses transform
            their operations and achieve sustainable growth.
      </p>
          <div className="about-stats">
            <div className="stat-item">
              <div className="stat-number">20+</div>
              <div className="stat-label">Integrated RFID Systems</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">4+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
          </div>
        </div>
        <div className="about-image">
          <img 
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80" 
            alt="MarsX Technology Team"
          />
        </div>
      </div>

      {/* Clients Section */}
      <div className="clients-section">
        <div className="section-header">
          <h2>Our Trusted Clients</h2>
          <p className="section-subtitle">
            Proud to partner with leading organizations
          </p>
        </div>
        <div className="clients-grid">
          <div className="client-item">
            <img 
              src={process.env.PUBLIC_URL + "/PDEA-logo.png"} 
              alt="PDEA Logo"
              className="client-logo client-logo-large"
            />
            <h3>PDEA</h3>
          </div>
          <div className="client-item">
            <img 
              src={process.env.PUBLIC_URL + "/jda-logo.png"} 
              alt="JDA Technologies Logo"
              className="client-logo"
            />
            <h3>JDA Technologies</h3>
          </div>
          <div className="client-item">
            <img 
              src={process.env.PUBLIC_URL + "/APB-logo.png"} 
              alt="APB Engineering Services Logo"
              className="client-logo client-logo-large"
            />
            <h3>APB Engineering Services</h3>
          </div>
        </div>
      </div>
    </section>
  );
}
